import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import MallBanner from './mallBanner';
import FirstPage from './firstPage';
import AUBanner from './auBanner';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';

export const AUTO_SWITCH_COUNTRIES = ['us', 'ca', 'uk', 'eu', 'de', 'fr', 'jp', 'kr', 'za', 'br', 'mx', 'ph'];
export const SHOW_PROS_THINK = ['us', 'ca', 'uk', 'eu', 'de', 'fr', 'za', 'au', 'br', 'mx', 'ph'];
if (typeof window !== 'undefined') {
    window.ScrollMagic = ScrollMagicFn();
    ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    window.controllerDelta2 = new ScrollMagic.Controller();
}
const PageConPc = dynamic(() => import('@/components/ProductDelta/Delta2new/indexDynamic'), {
    ssr: true,
});

const list = {
    br: ['product_ps_delta_delta_pro_plus', 'product_ps_delta_delta_2_max', 'product_ps_river_river_256'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_delta_delta_pro', 'product_ps_river_river_256'],
    ph: ['product_ps_river_river_256', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_3'],
    en: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_256'],
};

export default function Delta2({ theme }: any) {
    const { gloproductlist, useRouter, useEffect } = useGlobal();
    const { locale = 'us' } = useRouter();
    const otherProductData = getDetaileMoreProducts(
        gloproductlist,
        list?.[locale as 'en'] ?? list['en'],
        '',
        '',
        ['br'].includes(locale)
            ? 'https://br.ecoflow.com/collections/delta-series-portable-power-stations'
            : `https://${locale}.ecoflow.com/collections/portable-power-stations`,
    );

    useEffect(() => {
        return () => {
            setTimeout(() => {
                /* @ts-ignore */
                window.controllerDelta2?.destroy(true);
            }, 30);
        };
    }, []);

    return (
        <div className={`${css.delta2Pc} delta2Pc`}>
            {locale !== 'au' && (AUTO_SWITCH_COUNTRIES.includes(locale) ? <MallBanner /> : <FirstPage />)}
            {locale === 'au' && <AUBanner />}
            <PageConPc theme={theme} locale={locale} otherProductData={otherProductData} />
        </div>
    );
}
